import React from "react";
import { Typography, Table, Space, Button } from "antd";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";
import Date from "../../../tables/Date";
import Patient from "../../../tables/Patient";
import Employee from "../../../tables/Employee";
import moment from "moment";

const { Text } = Typography;

const SchedulingTable = (props) => {
  const { data, onEdit, onDelete, loading } = props;
  const intl = useIntl();

  const columns = [
    {
      title: intl.formatMessage({
        id: "app.scheduling.patientName",
      }),
      dataIndex: "patient",
      render(text, record) {
        return (
          <Patient
            record={{
              id: record.patient.id,
              branch: record.patient.branch,
              first_name: record.patient.first_name,
              surename: record.patient.surename,
            }}
          />
        );
      },
      width: "220px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.employeeName",
      }),
      dataIndex: "employee",
      width: "200px",
      render(text, record) {
        return <Employee record={text} />;
      },
    },
    {
      title: intl.formatMessage({
        id: "app.plans.weekday",
      }),
      dataIndex: "weekday",
      render(text) {
        return <Text>{text !== undefined && moment.weekdays(text)}</Text>;
      },
      width: "70px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.start_time",
      }),
      dataIndex: "start_time_minutes",
      render(text) {
        return (
          <Date
            text={text && moment().startOf("day").set("minute", text)}
            format={"HH:mm"}
          />
        );
      },
      width: "70px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.end_time",
      }),
      dataIndex: "end_time",
      render(text, record) {
        return (
          <Date
            text={
              record.start_time_minutes &&
              moment()
                .startOf("day")
                .set(
                  "minute",
                  record.duration_minutes + record.start_time_minutes
                )
            }
            format={"HH:mm"}
          />
        );
      },
      width: "70px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.duration",
      }),
      dataIndex: "duration_minutes",
      render(text) {
        return <Text>{Math.round((text / 60) * 100) / 100}</Text>;
      },
      width: "70px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.planType",
      }),
      dataIndex: "replacement",
      render(text) {
        return text ? (
          <Text>
            {intl.formatMessage({
              id: "app.plans.replacement",
            })}
          </Text>
        ) : (
          <Text>
            {intl.formatMessage({
              id: "app.plans.routine",
            })}
          </Text>
        );
      },
      width: "70px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.actions",
      }),
      responsive: ["md"],
      width: "130px",
      render(text, record) {
        return (
          <Space size="middle">
            <Button
              type="text"
              // disabled={editingKey !== ""}
              onClick={() => onEdit(record)}
            >
              <FormattedMessage id={"app.actions.edit"} />
            </Button>
            <Button
              // disabled={editingKey !== ""}
              danger
              type="text"
              onClick={() => onDelete(record)}
            >
              <FormattedMessage id={"app.actions.delete"} />
            </Button>
          </Space>
        );
      },
    },
  ];

  return (
    <Table
      bordered
      dataSource={data || []}
      columns={columns}
      rowKey={(record) => record.id}
      pagination={false}
      scroll={{
        y: window.innerHeight - 320,
      }}
      loading={loading}
    />
  );
};

export default SchedulingTable;
